module.exports = __webpack_public_path__ + "img/sketch10.11a264cb.png";